<script setup>
    import {
        ref,
        reactive,
        inject,
        onMounted,
        onUnmounted,
        computed
    } from 'vue';
    import {
        useStore
    } from 'vuex'
    const lang = localStorage.getItem('langrage')
    const langrage = inject('langrage');
    const store = useStore();

    // 活动相关
    const isActivity = computed(() => store.getters.isActivity);
</script>

<template>
    <div v-show="isActivity" class="top-promo">
        <div class="tp-marquee-wrap">
            <div class="tp-marquee">
                <span class="tp-promo-item">
                    <span class="pi-spec">🔥 {{ langrage.activityTip1 }}</span>
                    <!-- <span class="pi-spec">
                       <span class="ab-tag"/> {{ langrage.tabTitle }}100GB：$0.9/GB | 800GB：$0.6/GB
                    </span>
                    <span class="pi-spec">
                        <span class="ab-tag"/> {{ langrage.tabTitle2 }} 100GB：$1/GB | 800GB：$0.7/GB
                    </span> -->
                    <!-- <span class="pi-spec">
                        <span class="ab-tag"/> {{ langrage.tabTitle4 }} 100GB：$0.28/GB
                    </span> -->
                    <span class="pi-spec">
                        <span class="ab-tag"/> {{ langrage.tabTitle3 }} 100GB：$1.8/GB
                    </span>
                    
                    <span class="pi-spec">
                       💥{{ langrage.activityTip3 }}
                    </span>
                </span>


                <!-- 复制一组确保无缝循环 -->
                <span class="tp-promo-item">
                    <span class="pi-spec">🔥 {{ langrage.activityTip1 }}</span>
                    <!-- <span class="pi-spec">
                       <span class="ab-tag"/> {{ langrage.tabTitle }}100GB：$0.9/GB | 800GB：$0.6/GB
                    </span>
                    <span class="pi-spec">
                        <span class="ab-tag"/> {{ langrage.tabTitle2 }} 100GB：$1/GB | 800GB：$0.7/GB
                    </span> -->
                    <!-- <span class="pi-spec">
                        <span class="ab-tag"/> {{ langrage.tabTitle4 }} 100GB：$0.28/GB
                    </span> -->
                    <span class="pi-spec">
                        <span class="ab-tag"/> {{ langrage.tabTitle3 }} 100GB：$1.8/GB
                    </span>
                    
                    <span class="pi-spec">
                       💥{{ langrage.activityTip3 }}
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    // 顶部全宽活动通告条（走马灯）
    .top-promo {
        position: sticky;
        top: 0;
        z-index: 50;
        height: 40px;
        background: linear-gradient(90deg, #1f2330 0%, #2a1d2f 30%, #3a1f28 50%, #2a1d2f 70%, #1f2330 100%);
        color: #fff;
        display: flex;
        align-items: center;
        padding: 0;
        overflow: hidden;
        border-bottom: 1px solid rgba(255, 106, 61, 0.25);

        &::before {
            content: "";
            position: absolute;
            inset: 0;
            background: radial-gradient(ellipse at 50% 100%, rgba(255, 106, 61, 0.2) 0%, transparent 50%);
            pointer-events: none;
        }
    }

    // 走马灯轨道容器
    .tp-marquee-wrap {
        flex: 1 1 100%;
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        height: 100%;
        position: relative;
        mask-image: linear-gradient(90deg, transparent 0, #000 3%, #000 97%, transparent 100%);
        -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 3%, #000 97%, transparent 100%);
    }

    .tp-marquee {
        display: flex;
        align-items: center;
        height: 100%;
        width: max-content;
        animation: tp-marquee-scroll 50s linear infinite;

        &:hover {
            animation-play-state: paused;
        }
    }
    
    .ab-tag{
        display: inline-flex;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #fff;
        margin:0 5px 2px;
        animation: ab-pulse-35801cc1 1.4s ease-in-out infinite;
    }

    @keyframes tp-marquee-scroll {
        0% {
            transform: translateX(0);
        }

        100% {
            transform: translateX(-50%);
        }
    }

    // 单个促销项
    .tp-promo-item {
        display: inline-flex;
        align-items: center;
        gap: 18px;
        padding: 0 22px;
        font-size: 13px;
        line-height: 1;
        color: rgba(255, 255, 255, 0.92);
        white-space: nowrap;

        .pi-cat {
            color: #ff6a3d;
            font-weight: 700;
            letter-spacing: 0.3px;
        }

        .pi-spec {
            color: rgba(255, 255, 255, 0.95);
            font-weight: 500;
        }

        .pi-old {
            color: rgba(255, 255, 255, 0.45);
            text-decoration: line-through;
            font-size: 12px;
        }

        .pi-new {
            color: #ffb547;
            font-weight: 700;
            background: rgba(255, 181, 71, 0.12);
            padding: 3px 8px;
            border-radius: 3px;
        }

        .pi-flag {
            color: #ff6a3d;
            font-weight: 600;
            font-size: 11px;
            padding: 2px 6px;
            border: 1px solid rgba(255, 106, 61, 0.4);
            border-radius: 3px;
        }
    }

    // 分隔符
    .tp-divider {
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.18);
        flex-shrink: 0;
    }

    // 响应式
    @media (max-width: 760px) {
        .top-promo {
            height: 36px;
        }
    }
</style>